<template>
  <div class="h-[60vh] w-screen flex items-center justify-center">
    <div class="text-center">
      <h1 class="text-[128px] font-bold text-red-500 py-8">404</h1>
      <p class="text-3xl">Nothing to see here!</p>
      <p class="mt-4 text-lg">This page might have been moved, hidden, or removed. Most likely you will find it under the extras section!</p>
      <router-link to="/" class="text-lg mt-6 inline-block bg-green-500 hover:bg-green-700 duration-150 text-white py-2 px-4 rounded">Go Home</router-link>
    </div>
  </div>
</template>